<div class="form-group">
  <div class="row">
    <div class="col-xl-12">
      <div class="circle-icon">
        <span class="circle-info">
          <i class="fas fa-database"></i>
        </span>
        <span class="title">
          Open Finance
          <span class="subtitle">Meus compartilhamentos com instituições</span>
        </span>
      </div>
      <button mat-mini-fab class="btn-gray float-right ml-1" mat-dialog-close>
        <i class="fas fa-times button-close"></i>
      </button>
      <div class="buttons-top">
        <div class="search-box">
          <form [formGroup]="formFilter">
            <button class="btn-search"><i class="fas fa-search"></i></button>
            <input
              type="text"
              name="filter"
              class="input-search"
              placeholder="Pesquise aqui..."
              formControlName="filter"
              ngDefaultControl
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="form-group">
  <div class="row">
    <div class="col-xl-12">
      <div class="form-group">
        <div class="col-sm-12 t-overflow-auto">
          <table class="table table-condensed">
            <thead>
              <tr>
                <th>Instituição</th>
                <th>Tipo</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of listOpenFinance | filter: filter | paginate: { itemsPerPage: totalResults, currentPage: page}"
              >
                <td>{{item.content.connector.name}}</td>
                <td>{{item.content.connector.type}}</td>
                <td>
                  <button class="btn btn-rounder-view mr-1" (click)="updateWidgetPluggy(item.uuid)">
                    <i class="fas fa-redo"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!listOpenFinance || listOpenFinance.length === 0">
                <td colspan="5">
                  <div class="alert alert-info font-16 text-center">Não possui dados</div>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination-controls
            (pageChange)="page = $event"
            previousLabel="Anterior"
            nextLabel="Próximo"
          ></pagination-controls>
        </div>
      </div>
    </div>
  </div>
  <div class="row float-right">
    <button type="button" class="btn-secondary btn-rounder float-right" (click)="createWidgetPluggy()">
      Agendar com outra instituição
    </button>
  </div>
</div>
